import React, { useState } from 'react';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import TableTitle from './TableTitle';
import AfterTable from './AfterTable';
import ConfirmModal from '../B2BTable/ConfirmModal';
import CredentialWalmartModal from '../../CredentialWalmart/CredentialWalmart';
import { generalMuiForm } from '../../../commons/styles';
import SorianaCredentials from './SorianaCredentials'
import {
    SORIANA_AZURE_USER_TYPE,
    SORIANA_TRADITIONAL_USER_TYPE,
} from '../../../commons/constants';


const useStyles = makeStyles(() => ({
    input: {
        width: '100%',
        ...generalMuiForm,
        margin: 0,
        '& .MuiInputBase-root': {
            height: '38px',
            ...generalMuiForm['& .MuiInputBase-root'],
        }
    },
}));

const ContentTable = ({
    b2bTable,
    handleClickAddB2B,
    isLoading,
    portalInfoData,
    handleChangePortal,
    handleChangePortalLink,
    isErrorB2BAddRequest,
    removeLastB2BRowTable,
    isClickedAddB2BManual,
    showModal,
    setShowModal,
    handleChangeUserTypeWalmart,
    isGS1 = false,
}) => {
    const classes = useStyles();
    const [b2bFormData, setB2bFormData] = useState();
    const [errorValidationForm, setErrorValidationForm] = useState();
    const [isVisibleConfirmModal, seIsVisibleConfirmModal] = useState(false);
    const [showPassword, setShowPassword] = useState([]);

    const getPortalFake = () => ({
        is_b2b_manual: true,
        portal_country: portalInfoData[0].portal_country,
        portal_description: "",
        portal_id: -1,
        portal_link: "",
        portal_name: "",
        required_fields: [
            "username",
            "rut",
        ],
    })

    const isWalmart = (data) => ((data.portal || {}).portal_name || '')
        .toLowerCase()
        .includes('walmart')

    const isSoriana = (data) => ((data.portal || {}).portal_name || '')
        .toLowerCase()
        .includes('soriana')

    const renderUserRowContent = (data, index) => {
        let userRowContent = (
            <>
                <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                    Usuario*
                </span>
                <input
                    type="text"
                    className="form-rounded"
                    id="username"
                    name="username"
                    defaultValue={data.username || ''}
                    onChange={(e) => handleChangeInput(e.target.name, e.target.value, index)}
                    placeholder="Usuario"
                />
                {errorValidationForm && errorValidationForm[index].username &&
                    <span className="text text-bad">
                        Campo requerido
                    </span>
                }
            </>
        )

        if (isWalmart(data)) {
            userRowContent = (
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="userTypeWalmart"
                        name="userTypeWalmart"
                        value={(data.portal || {}).userType}
                        onChange={e => handleUserTypeWalmart(e, index)}
                    >
                        <FormControlLabel value="bot" control={<Radio />} label="Usuario BOT" />
                        <FormControlLabel value="symantec" control={<Radio />} label="Usuario Symantec VIP" />
                    </RadioGroup>
                </FormControl>
            )
        } else if (isGS1 && isSoriana(data)) {
            userRowContent = (
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="sorianaUserType"
                        name="sorianaUserType"
                        value={(data.portal || {}).userType}
                        onChange={(e) => handleSorianaUserType(e.target.value, index)}
                    >
                        <FormControlLabel
                            value={SORIANA_TRADITIONAL_USER_TYPE}
                            control={<Radio />}
                            label="Tradicional"
                        />
                        <FormControlLabel
                            value={SORIANA_AZURE_USER_TYPE}
                            control={<Radio />}
                            label="Azure"
                        />
                    </RadioGroup>
                </FormControl>
            )
        }

        return userRowContent
    }

    const renderPasswordRowContent = (data, index) => {
        let passwordRowContent = (
            <>
                <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                    Contraseña*
                </span>
                <div className="input-group mb-3 input-with-icon form-unit-element-hover">
                    <input
                        type={!!showPassword[index] ? 'text' : 'password'}
                        className="form-rounded unit-element"
                        id="password"
                        name="password"
                        defaultValue={data.password || ''}
                        onChange={(e) => handleChangeInput(e.target.name, e.target.value, index)}
                        placeholder="Contraseña"
                    />
                    <div className="input-group-append">
                        <button className="btn btn-outline-unit" onClick={(e) => handleClickShowPassword(e, index)}>
                            <i className={!!showPassword[index] ? 'far fa-eye-slash' : 'far fa-eye'} />
                        </button>
                    </div>

                    {index > 0 && index === b2bTable.length - 1 && (b2bTable[index] || Object.values(b2bTable[index]).every((el) => !el)) &&
                        showModal === false ? (
                        <div className="input-group-append">
                            <button className="btn btn-outline-danger" onClick={(e) => removeLastElementInRow(e, index)} title="Eliminar fila">
                                <i className="fas fa-minus" />
                            </button>
                        </div>
                        ) : null
                    }
                </div>
                {errorValidationForm && errorValidationForm[index].password &&
                    <span className="text text-bad">
                        Campo requerido
                    </span>
                }
            </>
        )

        if (isWalmart(data)) {
            passwordRowContent = (
                <CredentialWalmartModal
                    userType={(data.portal || {}).userType}
                    handleUserTypeWalmart={handleUserTypeWalmart}
                    b2bTable={b2bTable}
                    setB2bFormData={setB2bFormData}
                    portalInfo={data}
                    index={index}
                />
            )
        } else if (isGS1 && isSoriana(data)) {
            passwordRowContent = (
                <SorianaCredentials
                    portalData={data}
                    b2bTable={b2bTable}
                    rowIndex={index}
                    setB2bFormData={setB2bFormData}
                    disabled={!(data.portal || {}).userType}
                />
            )
        }

        return passwordRowContent
    }

    const validateFormData = (formData, sendData = false) => {
        if (formData.length === 1 && !(formData[0].portal, {}).portal_name && !sendData) {
            return false;
        }

        const errorForm = formData.map((data) => ({
            portal: !data.portal || !(data.portal || {}).portal_name ? true : false,
            portal_link: !(data.portal_link || (data.portal || {}).portal_link),
            username: !data.username,
            password: !data.password,
            rut: (
                data.portal
                && (
                    data.portal.required_fields || []
                ).includes("rut") && !data.rut
            ) && !(data.portal || {}).is_b2b_manual ? true : false,
        }));

        if (errorForm.some((err) => Object.values(err).some((e) => e))) {
            setErrorValidationForm(errorForm);
            return true;
        }
        return false;
    };

    const getFixedFormData = (formData, addB2BManual) => {
        const result = formData.map((data) => ({
            portal: {
                ...data.portal,
                portal_link: data.portal_link || (data.portal || {}).portal_link || '',
                is_b2b_manual: (data.portal || {}).is_b2b_manual !== undefined ? data.portal.is_b2b_manual : addB2BManual,
                required_fields: addB2BManual && (!data.portal || data.portal.is_b2b_manual) ? ["username", "rut"] : (data.portal || {}).required_fields,
                portal_country: (data.portal || {}).portal_country !== undefined ? data.portal.portal_country : getPortalFake().portal_country,
                portal_id: (data.portal || {}).portal_id !== undefined ? data.portal.portal_id : getPortalFake().portal_id,
            },
            category: isClickedAddB2BManual && data.portal && data.portal.is_b2b_manual ? "" : data.category || 'Genérico',
            username: data.username,
            password: data.password,
            rut: data.rut || null,
        }));

        if (result.length === 1 && result[0].portal && result[0].portal.is_b2b_manual) {
            result[0].portal = {
                ...result[0].portal,
                portal_country: portalInfoData[0].portal_country,
                portal_id: -1,
                portal_name: result[0].portal && result[0].portal.portal_name ? result[0].portal.portal_name : "fake",
            }
        }

        return result
    };

    const handleSubmit = (e, completed, openModal, addB2BManual = false) => {
        e.preventDefault();
        if (isLoading) return;

        setErrorValidationForm(null);
        let formData = b2bFormData || b2bTable;
        if (formData && formData.length < b2bTable.length) {
            formData = [...formData, {}];
        }

        if (validateFormData(formData)) return;

        handleClickAddB2B(
            getFixedFormData(
                formData,
                addB2BManual
            ),
            completed,
            openModal,
            addB2BManual,
        );
    };

    const onBlurB2BManual = (value, portal) => {
        let portalFake = null;

        if (portal) {
            portalFake = JSON.parse(JSON.stringify(portal));
        } else {
            portalFake = getPortalFake()
        }

        portalFake.portal_name = value.target.value;
        portalFake.portal_description = value.target.value;

        const lastRecord = b2bTable.length - 1
        const credentials = b2bTable[lastRecord]
        const b2bFormDataCopied = b2bTable;

        credentials['portal'] = portalFake
        b2bFormDataCopied[lastRecord] = credentials

        setB2bFormData(b2bFormDataCopied);
    }

    const handleChangeInput = (name, value, index) => {
        const b2bSingularData = b2bTable[index];
        b2bSingularData[name] = value;
        const b2bFormDataCopied = b2bTable;
        b2bFormDataCopied[index] = b2bSingularData;
        setB2bFormData(b2bFormDataCopied);
    };

    const handleGetOptionSelected = (event, value, index) => {
        handleChangeInput('portal', value, index);
        handleChangePortal(value, index);
    };

    const handleClickShowPassword = (e, index) => {
        e.preventDefault();
        const showPasswordCopied = [...showPassword];
        showPasswordCopied[index] = !showPassword[index];
        setShowPassword(showPasswordCopied);
    };

    const handleClickGoToPortal = (e, index) => {
        e.preventDefault();
        const url = b2bTable[index].portal_link;
        if (url) {
            window.open(url);
        }
    };

    const handleChangePortalLinkValue = (value, index) => {
        handleChangePortalLink(value, index);
        handleChangeInput('portal_link', value, index);
    };

    const removeLastElementInRow = (e, index) => {
        e.preventDefault();
        if (b2bFormData) {
            const newFormData = [...b2bFormData];
            newFormData.splice(index, 1);
            setB2bFormData(newFormData);
        }
        removeLastB2BRowTable();
    };

    const handleUserTypeWalmart = (e, index) => {
        const userTypeValue = e.target.value;
        const b2bSingularData = b2bTable[index];
        b2bSingularData.portal.userType = userTypeValue;
        const b2bFormDataCopied = b2bTable;
        b2bFormDataCopied[index] = b2bSingularData
        setB2bFormData(b2bFormDataCopied);
        handleChangeUserTypeWalmart(b2bSingularData, index);
    }

    const handleSorianaUserType = (userType, index) => {
        const updatedB2BTable = [...b2bTable]
        updatedB2BTable[index] = {
            ...b2bTable[index],
            username: '',
            password: '',
            rut: '',
            portal: {
                ...b2bTable[index].portal,
                userType,
            }
        }
        setB2bFormData(updatedB2BTable)
        handleChangeUserTypeWalmart(updatedB2BTable[index], index)
    }

    return (
        <>
            <TableTitle hideColumn={showModal}/>
            <div className="container-table-content">
                {b2bTable.map((data, index) =>
                    <div key={index} className="container-table-content">
                        <div className="row">
                            <div className={
                                    showModal !== false
                                        ? "col-lg-2 col-md-4 col-sm-4 col-xs-12"
                                        : "col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                } style={{ marginBottom: '10px', marginTop: '10px' }}>
                                <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                                    Portal B2B Cadena*
                                </span>
                                { (!data.portal && !isClickedAddB2BManual) || (data.portal && !data.portal.is_b2b_manual)
                                    ?
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        name="portal_id"
                                        options={portalInfoData}
                                        getOptionLabel={(option) => option.portal_name}
                                        onChange={(e, v) => handleGetOptionSelected(e, v, index)}
                                        defaultValue={data.portal || ''}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => <TextField {...params} className={classes.input} variant="outlined" margin="dense" name="portal_id" placeholder="Portal" />}
                                        noOptionsText="Portal no encontrado"
                                        closeText="Cerrar"
                                    /> : <TextField
                                        required
                                        className="form-rounded unit-element"
                                        id="b2b_manual_name"
                                        name="b2b_manual_name"
                                        defaultValue={
                                            data.portal && data.portal.portal_name ? data.portal.portal_name : ""
                                        }
                                        placeholder="Nombre del portal"
                                        onBlur={(name) => onBlurB2BManual(name, data.portal)}
                                    />
                                }
                                { errorValidationForm && errorValidationForm[index].portal &&
                                    <span className="text text-bad">
                                        Campo requerido
                                    </span>
                                }
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                                    Link portal B2B*
                                </span>
                                <div className="input-group mb-3 input-with-icon form-unit-element-hover">
                                    <input
                                        type="text"
                                        className="form-rounded unit-element"
                                        id="portal-url"
                                        name="portal_link"
                                        value={(data.portal_link || (data.portal || {}).portal_link || '').trim()}
                                        onChange={(e) => handleChangePortalLinkValue(e.target.value, index)}
                                        placeholder="http://www.b2b.com"
                                    />
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-unit" onClick={(e) => handleClickGoToPortal(e, index)} title="Ir al portal" >
                                            <i className="fas fa-external-link-alt"/>
                                        </button>
                                    </div>
                                </div>
                                {errorValidationForm && errorValidationForm[index].portal_link &&
                                    <span className="text text-bad">
                                        Campo requerido
                                    </span>
                                }
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                                    Proveedor - Categoría (opcional)
                                </span>
                                <input
                                    type="text"
                                    className="form-rounded"
                                    id="provider"
                                    name="category"
                                    defaultValue={data.category || ''}
                                    onChange={(e) => handleChangeInput(e.target.name, e.target.value, index)}
                                    placeholder={
                                        isClickedAddB2BManual
                                        || data.portal !== undefined && data.portal && data.portal.is_b2b_manual
                                        ? "" : "Proveedores"
                                    }
                                    disabled={
                                        !isClickedAddB2BManual && (
                                            data.portal === undefined
                                            || (data.portal || {}).is_b2b_manual === undefined
                                            || (data.portal || {}).is_b2b_manual === false
                                        )
                                        || isClickedAddB2BManual && data.portal && data.portal.is_b2b_manual === false
                                        ? false : true
                                    }
                                />
                            </div>
                            <div
                                className={
                                    showModal !== false
                                        ? "col-lg-2 col-md-4 col-sm-4 col-xs-12"
                                        : "col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                }
                                style={{ marginBottom: '10px', marginTop: '10px' }}
                            >
                                {renderUserRowContent(data, index)}
                            </div>
                            <div
                                className="col-lg-2 col-md-4 col-sm-4 col-xs-12"
                                style={{ marginBottom: '10px', marginTop: '10px' }}
                            >
                                {renderPasswordRowContent(data, index)}
                            </div>
                            {showModal !== false ? (
                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                    {
                                        !((data.portal || {}).portal_name || "").toLowerCase().includes("walmart") && <>
                                            <span className="bold-text-2 d-block d-lg-none d-xl-none" style={{ marginBottom: '5px' }}>
                                                RUT o RUC Empresa{((data.portal || {}).required_fields || []).includes("rut") && '*'}
                                            </span>
                                            <div className="input-group mb-3 input-with-icon">
                                                <input
                                                    type="text"
                                                    className="form-rounded"
                                                    id="rut"
                                                    name="rut"
                                                    defaultValue={data.rut || ''}
                                                    onChange={(e) => handleChangeInput(e.target.name, e.target.value, index)}
                                                    placeholder={((data.portal || {}).required_fields || []).includes("rut") ? 'rut o ruc' : ''}
                                                    disabled={!((data.portal || {}).required_fields || []).includes("rut")}
                                                />
                                                {errorValidationForm && errorValidationForm[index].rut &&
                                                    <span className="text text-bad">
                                                        Campo requerido
                                                    </span>
                                                }
                                                {index > 0 && index === b2bTable.length - 1 && (b2bTable[index] || Object.values(b2bTable[index]).every((el) => !el)) &&
                                                    <button className="btn btn-outline-danger" onClick={(e) => removeLastElementInRow(e, index)} title="Eliminar fila">
                                                        <i className="fas fa-minus" />
                                                    </button>
                                                }
                                            </div>
                                        </>
                                    }
                                    { ((data.portal || {}).portal_name || "").toLowerCase().includes("walmart") && index > 0 && index === b2bTable.length - 1 && (b2bTable[index] || Object.values(b2bTable[index]).every((el) => !el)) &&
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-danger" onClick={(e) => removeLastElementInRow(e, index)} title="Eliminar fila">
                                                <i className="fas fa-minus" />
                                            </button>
                                        </div>
                                    }
                                </div>
                            ) : null}
                        </div>
                    </div>
                )}
                {showModal !== false ? (
                <div className="row">
                    <div className="col-12">
                        ¿Tu portal no está en la lista?
                        <a href="" onClick={(e) => handleSubmit(e, false, false, true)}> Haz click acá</a>
                    </div>
                </div>
                ) : null}
                <div style={{ height: '2px', backgroundColor: '#e2e3eb', margin: '10px' }}/>
                <div className="row justify-content-center m-3">
                    <div className="col-12">
                        <button
                            className="isv-btn isv-btn-circle btn-warning btn-block m-auto"
                            onClick={(e) => handleSubmit(e, false, false, false)}
                        >
                            <Icon className="fas fa-plus-circle" style={{ fontSize: 11 }}></Icon>
                            Agregar fila
                        </button>
                    </div>
                </div>
                {isErrorB2BAddRequest &&
                    <div className="row justify-content-end" style={{ marginBottom: "15px" }}>
                        <div className="col-12">
                            <span className="text text-bad-center">
                                No se pudo procesar su solicitud, intente más tarde.
                            </span>
                        </div>
                    </div>
                }
            </div>
            {showModal === true ? (
                <AfterTable />
            ) : null}
            <div className="row justify-content-end m-1">
        <div className="col-xs-12 col-lg-2 col-md-3 col-sm-5">
          <button
            className="isv-btn isv-btn-circle btn-red btn-font btn-size btn-block"
            onClick={(e) => {
              e.preventDefault();
              if (isLoading) return;

              setErrorValidationForm(null);
              let formData = b2bFormData || b2bTable;
              if (formData && formData.length < b2bTable.length) {
                formData = [...formData, {}];
              }

              if (validateFormData(formData, true)) return;

              if (showModal !== false) {
                seIsVisibleConfirmModal(true);
              } else {
                handleSubmit(e, true, true);
              }
            }}
            disabled={isLoading}
          >
            {isLoading && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}{' '}
            Enviar datos
          </button>
        </div>
      </div>
      <ConfirmModal
        showModal={isVisibleConfirmModal}
        handleClickOKModal={(e) => {
          seIsVisibleConfirmModal(false);
          handleSubmit(e, true, true);
        }}
        handleClickCancelModal={() => seIsVisibleConfirmModal(false)}
      />
    </>
  );
};

export default ContentTable;
